import { useState  } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import axios from 'axios';
import API from '../utils/api';
import Alerta from '../Alerta';
import Select from "react-select";

function PagarCuotaModal({modal, setModal, detalle, getVentaDetalle }) {
  const [monto, setMonto] = useState('');
  const [alerta, setAlerta] = useState({})
  const {IdVentaCuota, Cuota, CuotaOriginal, CoutaConInteres} = detalle 

  const [MedioPago, setMedioPago] = useState("");
  const mediosPagos = [
    { value: "TR", label: "Transferencia" },
    { value: "EF", label: "Efectivo" },
  ];
  
  var url = API.urlAPI + "ventacuotasdetalles/PagoCuota/"
  const handleSubmit = async () => {
  const urlPago =  url+ IdVentaCuota
  var interes = false
  var estado

    //Valido que el monto no este vacio
    if([monto, MedioPago].includes('')){
        setAlerta({
               msg: 'Todos los campos son obligatorios',
               error: true
           });
       return
   }

    //Valido que el monto sea mayor a cero
   if (monto <= 0 ){
        setAlerta({
            msg: 'El pago debe ser mayor a cero',
            error: true
           });
        return
    }
    if (monto > CuotaOriginal) {
      var nuevacuota = monto   
     
    }
    console.log("entro en cuota con interes -> ", nuevacuota)

   
   //Defino el estado de la cuota

   if (interes){
    if(monto< CoutaConInteres ){
      estado = "Pago Parcial"
    }else{
      estado = "Pago Completo"
    }
   }else{
    if(monto< CuotaOriginal ){
        estado = "Pago Parcial"
      }else{
        estado = "Pago Completo"
      }
   }


    try {
        const fecha = new Date();
        const { data } = await axios.put(urlPago, {"MontoPago":monto ,"Estado":estado, "FechaRegistro": fecha, "medioPago" : MedioPago.value, "CuotaConInteres" : nuevacuota  })
        setAlerta({})
        setTimeout(() => {getVentaDetalle()}, 500) 
    console.log(urlPago, {"MontoPago":monto ,"Estado":estado, "FechaRegistro": fecha, "medioPago" : MedioPago.value, "CuotaConInteres" : nuevacuota })
    } catch (error) {
      console.log(error.response.data.msg)
        setAlerta({
            msg: error.response.data.msg,
            error: true
        })
    }

    console.log(urlPago)
    setModal(false);

  }
  const { msg } = alerta
  return (
    <>


      <Modal show={modal} onHide={() => setModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{`Registro de pago - cuota ${Cuota}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
          {msg && 
            <Alerta alerta={alerta}></Alerta>
        } 
            <Form.Group controlId="monto">
              <Form.Label>Monto:</Form.Label>
              <Form.Control type="number" placeholder="Ingrese el monto del pago" value={monto} onChange={(e) => setMonto(e.target.value)} />
            </Form.Group>
            <br></br>
            <Form.Group controlId="medioPago">
              <Select
                className="input-cont"
                placeholder="Medio de pago"
                options={mediosPagos}
                isClearable={true}
                isSearchable={true}
                onChange={(e) => setMedioPago(e)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModal(false)}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PagarCuotaModal;